import { setError } from '../App/ErrorsActions';

import customFieldsUtils from '../../util/customFieldsUtils';
import CalculationsWorker from '../../services/worker';

export const ERROR = 'CTB_ERROR';
export const LOADING = 'CTB_LOADING';
export const SUCCESS = 'CTB_SUCCESS';
export const SUCCESS_BREAKDOWN = 'CTB_SUCCESS_BREAKDOWN';

export function isLoading(bool) {
  return {
    type: LOADING,
    isLoading: bool
  };
}

export function success(data) {
  return {
    type: SUCCESS,
    data
  };
}

function successBreakdown(data) {
  return {
    type: SUCCESS_BREAKDOWN,
    data
  };
}

export function getData() {
  return async (dispatch, getState) => {
    dispatch(isLoading(true));

    const { user } = getState().auth;
    const { selected } = getState().dashboards;
    const { data } = getState().app;

    const allFilters = getState().filters;
    const {
      chart,
      allCustomFields,
      excludeWeekends,
      workStart,
      workEnd,
      holidays,
      dates,
      enabledColors,
      ctb
    } = allFilters;
    const filters = chart === 'overview' ? allFilters.overview : ctb;

    const customFields = customFieldsUtils.getSelected(allCustomFields, filters);

    const service = new CalculationsWorker();
    let worker = service.wrap();
    worker = await new worker(selected, data, enabledColors, {
      isCsv: selected.isCsv,
      enableHistory: true,
      enableDoneFilters: user.config.enableDoneFilters,
      enableMissingDoneActivitiesInserting: user.config.enableMissingDoneActivitiesInserting
    });
    try {
      const ctbData = await worker.CycleTimeBreakdown({
        lists: filters.selectedLists,
        labels: filters.selectedLabels,
        members: filters.selectedMembers,
        customFields,
        from: dates.startDate.toISOString(),
        to: dates.endDate.toISOString(),
        timeUnit: ctb.timeUnit,
        excludeWeekendOpts: {
          type: excludeWeekends,
          workStart,
          workEnd,
          holidays
        },
        blockedTime: ctb.blockedTime,
        blockers: ctb.blockers,
        breakdownBy: filters.breakdownBy
      });
      dispatch(success(ctbData));
    } catch (err) {
      dispatch(setError(err));
    }
  };
}

export function getBreakdownData(ctbData) {
  return async (dispatch, getState) => {
    try {
      const { selected } = getState().dashboards;
      const { data } = getState().app;
      const { blockedTime, breakdownBy, timeUnit, blockers } = getState().filters.ctb;

      const service = new CalculationsWorker();
      let worker = service.wrap();
      worker = await new worker(selected, data);
      const breakdownData = await worker.GetBreakdownData(ctbData, blockedTime, breakdownBy, timeUnit, blockers);
      dispatch(successBreakdown(breakdownData));
    } catch (err) {
      dispatch(setError(err));
    }
  };
}
